module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAABSUlEQVQokZXTP0ucQRDH8Y/niQYL0fIBK8UqggTBxlbwBYiV2HmQIolFLNIHJIIBQXwDgmBvYatoIagJBEkhxO6aYFAIKoJ/WJkH1uME7wcPM+zsfmd2dp62Wq0G0/iEQXSggnt8x1cM4APWcSRTURSqmMSm5hqK1Vok+YhRHOe7E2Qp/C2s4BLXuMPviN2EbcMexvArhwyHn7KcNamnM75Sb6KScRyUkByYtIYptEdfHtDdAK5GRSM4qUbZ6cBtbHj/Qn8alc4e1uv1iUoWKP36KyFJXdipNAk8tAB5Sp5D7sP2tQj5XIlnE0OWdNoCYL4oiuVq1oursO/i2VOz052TncNMIyDm6gnwNxZnw6bX+hnjvY9d/Gi8QgkoId/CX8R//MMFzrEQsf4MkP6h5ZyYIGlhI0Y7DVUveqLBb2PfNv7gC1af1YRHZoo9A3q/xbgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/imgs/icon/icon_quit.png
// module id = DsZb
// module chunks = 41